import axios from 'axios';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: false,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const pricingService = {
  // Get all pricing plans
  getPricingPlans: async () => {
    try {
      const response = await api.get('/pricing');
      return response.data;
    } catch (error) {
      console.error('Get pricing plans error:', error);
      throw error;
    }
  },

  // Get pricing plan by ID
  getPricingPlanById: async (id) => {
    try {
      const response = await api.get(`/pricing/${id}`);
      return response.data;
    } catch (error) {
      console.error('Get pricing plan by ID error:', error);
      throw error;
    }
  },

  // Get pricing plan by name
  getPricingPlanByName: async (name) => {
    try {
      const response = await api.get(`/pricing/name/${name}`);
      return response.data;
    } catch (error) {
      console.error('Get pricing plan by name error:', error);
      throw error;
    }
  },
};

export default pricingService;
